import { InfoOutlined } from "@mui/icons-material";
import { List, ListItem, Paper, } from "@mui/material";
import { ProfileDocumentType, ProfileDocumentTypeLabel } from "../../common/ProfileDocument";

const DefaultJobRequirementsDisplay = () => {
  return (
    <>
    <Paper className="checklist">
      <div>
        <h3>Requirements</h3>
      </div>
      <List className="progress-list">
        <ListItem key={"mmc"} className="progress-item-wrap">
          <div className="progress-item no-check">
            <p className="progress-description">
              {ProfileDocumentTypeLabel[ProfileDocumentType.MMC]}
            </p>
          </div>
        </ListItem>
        <ListItem key={"passport"} className="progress-item-wrap">
        <div className="progress-item no-check">
            <p className="progress-description">
          {ProfileDocumentTypeLabel[ProfileDocumentType.PASSPORT]}
          </p>
          </div>
        </ListItem>
        <ListItem key={"twic"} className="progress-item-wrap">
        <div className="progress-item no-check">
            <p className="progress-description">
          {ProfileDocumentTypeLabel[ProfileDocumentType.TWIC]}
          </p>
          </div>
        </ListItem>
        <ListItem key={"med"} className="progress-item-wrap">
          <div className="progress-item no-check">
            <p className="progress-description">
              Medical certificate, and medical waiver (if applicable).
            </p>
          </div>
        </ListItem>
        <ListItem key={"other"} className="progress-item-wrap">
        <div className="progress-item no-check">
            <p className="progress-description">
          <InfoOutlined color="info" />{" Additional documents may be required."}
          </p>
          </div>
        </ListItem>
      </List>
    </Paper>
    </>
  );
};

export default DefaultJobRequirementsDisplay;

